/**
 * Newsletter Form - Simple Validation
 * Enables submit button when email field has a valid value
 */
if (!customElements.get('newsletter-form')) {
  customElements.define('newsletter-form', class NewsletterForm extends HTMLElement {
    constructor() {
      super();
      this.submitButton = this.querySelector('.newsletter-submit');
      this.emailInput = this.querySelector('input[type="email"]');
      
      if (!this.submitButton || !this.emailInput) return;
      
      this.updateButtonState();
      this.emailInput.addEventListener('input', () => this.updateButtonState());
    }

    updateButtonState() {
      const emailHasValue = this.emailInput.value.trim() !== '';
      this.submitButton.disabled = !emailHasValue;
    }
  });
}
